import axios from 'axios'
import getAttributes from '../store/attributes'

// Example input:
//   server: { sso: { slinger: 'asdf' }, name: 'Tranquility' }
//   code: 'asdfadsfadsf'
//   rememberAccount: true|false
//   autoLaunch: true|false
export const ltsLogin = (server, ssoCode, rememberAccount, autoLaunch, locale) => {
    if (server.sso.slinger === undefined) {
        throw Error(`Token service for ${server.name} is undefined`)
    }

    // Generate the source
    const source = getAttributes(locale).service.slinger.verify.replace(
        '{host}',
        server.sso.slinger,
    )

    // Send the code to the token service and retrieve
    // the token/user information
    return axios({
        method: 'post',
        url: source,
        data: {
            token: ssoCode,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(({ data: ssoUser }) => {
            if (ssoUser.UserName == null) {
                throw Error('Username was not properly set for loginUser object')
            }

            // Create the new user object
            return {
                // hash: ssoUser.HashedUserID,
                userId: ssoUser.UserName,
                pinned: rememberAccount,
                autoLaunch,
                tokens: {
                    access: ssoUser.AccessToken,
                    refresh: ssoUser.RefreshToken,
                },
            }
        })
        .catch((error) => {
            // Commonly used error message
            const commonErrorMessage = 'Could not finish login of user with code:'

            // Handle the type of error we're encountering
            if (error.response == null && error.message === 'Network Error') {
                // No connection could be established
                console.info(`${commonErrorMessage} Request failed, could not connect to ${source}`)
            } else if (error.response != null) {
                // Error reported from the token service
                const statusText = error.response.statusText
                console.info(`${commonErrorMessage} ${error.message} ${statusText}`)
            } else {
                // Other errors
                console.info(`${commonErrorMessage} ${error.message}`)
            }

            return { isError: true, error }
        })
}

export const ltsGetEula = locale => axios({
    method: 'get',
    url: '/agreements/EVE/EULA', // todo: rest of the URL is missing
    headers: {
        'Content-Type': 'application/json',
        'Accept-Language': locale.toUpper(),
    },
})
    .then(({ data }) => ({
        eula: data.DocumentText,
        hash: data.HashCode,
    }))
    .catch(error => ({ isError: true, error }))

export const ltsAcceptEula = (accessToken, eulaHash) => axios({
    method: 'put',
    url: '/agreements/EVE/EULA', // todo: rest of the URL is missing
    data: { token: accessToken, agreementHash: eulaHash },
    headers: {
        'Content-Type': 'application/json',
    },
})
    .then(({ data: success }) => ({ isError: false, success }))
    .catch(error => ({ isError: true, error }))



// WEBPACK FOOTER //
// ./src/launcherBackend/lts-service.js